export const folio = [
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg',
    title: 'Design component systems, not pages.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 420,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
    title: 'Run your business on profit, not credit.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 300,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
    title: 'Write documentation for everything.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 550,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
    title: 'Run your business on profit, not credit.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 494,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
    title: 'Build a culture where everyone designs.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 350,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
    title: 'Detach your worth from your work.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 550,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
    title: 'Designers can learn from interior design.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 350,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg',
    title: 'Build a culture where everyone designs.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 518,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
    title: 'Detach your worth from your work.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 550,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
    title: 'Write documentation for everything.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 450,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg',
    title: 'Design component systems, not pages.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 450,
  },
  {
    cover: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
    title: 'Run your business on profit, not credit.',
    subtitle:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.',
    h: 320,
  },
];

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];
